/**
 * Compatibility shim: replaces next/navigation hooks with React Router equivalents.
 */
import { useMemo } from 'react';
import { useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom';

export function useRouter() {
  const navigate = useNavigate();

  return useMemo(() => ({
    push: (url: string) => navigate(url),
    replace: (url: string) => navigate(url, { replace: true }),
    back: () => navigate(-1),
    forward: () => navigate(1),
    refresh: () => window.location.reload(),
    prefetch: (_url: string) => {}, // no-op in Vite
  }), [navigate]);
}

export function usePathname(): string {
  const location = useLocation();
  return location.pathname;
}

export function useSearchParamsCompat() {
  const [searchParams] = useSearchParams();
  return searchParams;
}

// Alias so `import { useSearchParams } from 'next/navigation'` works
export { useSearchParamsCompat as useSearchParams };

export { useParams } from 'react-router-dom';

// Re-export redirect/notFound as simple helpers
export function redirect(url: string): never {
  window.location.href = url;
  throw new Error('Redirect');
}

export function notFound(): never {
  throw new Response('Not Found', { status: 404 });
}
